module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.report) ? _c('div', {
    staticClass: "mex-rpt"
  }, [_c('div', {
    staticClass: "mex-rpt-hero"
  }, [_c('div', {
    staticClass: "mex-rpt-hero-copy"
  }, [_c('p', {
    staticClass: "mex-rpt-kicker"
  }, [_vm._v(_vm._s(_vm.kicker))]), _vm._v(" "), _c('div', {
    staticClass: "mex-rpt-score-row"
  }, [_c('span', {
    staticClass: "mex-rpt-score"
  }, [_vm._v(_vm._s(_vm.scoreInt))]), _vm._v(" "), _c('span', {
    staticClass: "mex-rpt-score-unit"
  }, [_vm._v("分")])]), _vm._v(" "), (_vm.isPlacement && _vm.formalLevelText) ? _c('p', {
    staticClass: "mex-rpt-level"
  }, [_vm._v("\n        综合等级 "), _c('b', [_vm._v(_vm._s(_vm.formalLevelText))])]) : (_vm.isPlacement && _vm.publishStatusText) ? _c('p', {
    staticClass: "mex-rpt-level mex-rpt-level-soft"
  }, [_vm._v("\n        " + _vm._s(_vm.publishStatusText) + "\n        "), (_vm.candidateLevelText) ? [_vm._v(" · 候选 "), _c('b', [_vm._v(_vm._s(_vm.candidateLevelText))])] : _vm._e(), _vm._v(" "), (_vm.visitedLevelText) ? [_vm._v(" · 触达 " + _vm._s(_vm.visitedLevelText))] : _vm._e()], 2) : _vm._e(), _vm._v(" "), (_vm.isSummative && _vm.promotionText) ? _c('p', {
    staticClass: "mex-rpt-promo"
  }, [_vm._v(_vm._s(_vm.promotionText))]) : _vm._e(), _vm._v(" "), (_vm.showPercentile) ? _c('p', {
    staticClass: "mex-rpt-peer"
  }, [_vm._v("\n        超过 "), _c('em', [_vm._v(_vm._s(_vm.report.nationalPercentile) + "%")]), _vm._v(" 同龄学员\n      ")]) : _c('p', {
    staticClass: "mex-rpt-peer mex-rpt-peer-muted"
  }, [_vm._v("全国样本不足，暂不对标")]), _vm._v(" "), (_vm.report.title) ? _c('p', {
    staticClass: "mex-rpt-title"
  }, [_vm._v(_vm._s(_vm.report.title) + " · " + _vm._s(_vm.medalText))]) : _vm._e()]), _vm._v(" "), _c('img', {
    staticClass: "mex-rpt-fox",
    attrs: {
      "src": _vm.foxSrc,
      "alt": ""
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "mex-rpt-card"
  }, [_c('h3', {
    staticClass: "mex-rpt-h"
  }, [_c('img', {
    staticClass: "mex-rpt-h-ico",
    attrs: {
      "src": _vm.radarIconSrc,
      "alt": ""
    }
  }), _vm._v("\n      综合能力评估\n    ")]), _vm._v(" "), (_vm.radarPlot) ? _c('div', {
    staticClass: "mex-rpt-radar-box"
  }, [_c('ul', {
    staticClass: "mex-rpt-legend"
  }, [_vm._m(0), _vm._v(" "), (_vm.cityLine) ? _c('li', [_c('i', {
    staticClass: "mex-rpt-dot mex-rpt-dot-city"
  }), _vm._v(_vm._s(_vm.cityLegend))]) : _vm._e(), _vm._v(" "), (_vm.nationLine) ? _c('li', [_c('i', {
    staticClass: "mex-rpt-dot mex-rpt-dot-nation"
  }), _vm._v("全国学生标准")]) : _vm._e()]), _vm._v(" "), _c('svg', {
    staticClass: "mex-rpt-svg",
    attrs: {
      "viewBox": "0 0 420 360"
    }
  }, [_vm._l((_vm.radarPlot.rings), function(ring, i) {
    return _c('polygon', {
      key: 'r' + i,
      staticClass: "mex-rpt-ring",
      attrs: {
        "points": ring
      }
    })
  }), _vm._v(" "), _vm._l((_vm.radarPlot.axes), function(ax, i) {
    return _c('line', {
      key: 'a' + i,
      staticClass: "mex-rpt-axis",
      attrs: {
        "x1": _vm.radarPlot.cx,
        "y1": _vm.radarPlot.cy,
        "x2": ax.x2,
        "y2": ax.y2
      }
    })
  }), _vm._v(" "), (_vm.radarPlot.nationPoly) ? _c('polygon', {
    staticClass: "mex-rpt-poly-nation",
    attrs: {
      "points": _vm.radarPlot.nationPoly
    }
  }) : _vm._e(), _vm._v(" "), (_vm.radarPlot.cityPoly) ? _c('polygon', {
    staticClass: "mex-rpt-poly-city",
    attrs: {
      "points": _vm.radarPlot.cityPoly
    }
  }) : _vm._e(), _vm._v(" "), _c('polygon', {
    staticClass: "mex-rpt-poly-self",
    attrs: {
      "points": _vm.radarPlot.selfPoly
    }
  }), _vm._v(" "), _vm._l((_vm.radarPlot.selfDots), function(d, i) {
    return _c('circle', {
      key: 'd' + i,
      staticClass: "mex-rpt-self-dot",
      attrs: {
        "cx": d.x,
        "cy": d.y,
        "r": "4"
      }
    })
  }), _vm._v(" "), _vm._l((_vm.radarPlot.axes), function(ax, i) {
    return _c('text', {
      key: 'l' + i,
      staticClass: "mex-rpt-axis-lab",
      attrs: {
        "x": ax.lx,
        "y": ax.ly,
        "text-anchor": "middle"
      }
    }, [_vm._v(_vm._s(ax.label))])
  })], 2)]) : _c('p', {
    staticClass: "mex-rpt-hint"
  }, [_vm._v("暂无雷达数据")]), _vm._v(" "), _c('p', {
    staticClass: "mex-rpt-foot"
  }, [_vm._v(_vm._s(_vm.radarFoot))])]), _vm._v(" "), (_vm.isPlacement) ? _c('div', {
    staticClass: "mex-rpt-card"
  }, [_c('h3', {
    staticClass: "mex-rpt-h"
  }, [_c('img', {
    staticClass: "mex-rpt-h-ico",
    attrs: {
      "src": _vm.dimIconSrc,
      "alt": ""
    }
  }), _vm._v("\n      英语能力等级对照表\n    ")]), _vm._v(" "), _c('div', {
    staticClass: "mex-rpt-table-wrap"
  }, [_c('table', {
    staticClass: "mex-rpt-table"
  }, [_c('thead', [_c('tr', [_c('th'), _vm._v(" "), _vm._l((_vm.levelCols), function(col) {
    return _c('th', {
      key: col.code,
      class: {
        'is-on': col.code === _vm.levelText
      }
    }, [_vm._v(_vm._s(col.code))])
  })], 2)]), _vm._v(" "), _c('tbody', [_c('tr', [_vm._m(1), _vm._v(" "), _vm._l((_vm.levelCols), function(col) {
    return _c('td', {
      key: 'c' + col.code,
      class: {
        'is-on': col.code === _vm.levelText
      }
    }, [_vm._v(_vm._s(col.ccss))])
  })], 2), _vm._v(" "), _c('tr', [_vm._m(2), _vm._v(" "), _vm._l((_vm.levelCols), function(col) {
    return _c('td', {
      key: 'e' + col.code,
      class: {
        'is-on': col.code === _vm.levelText
      }
    }, [_vm._v(_vm._s(col.cefr))])
  })], 2), _vm._v(" "), _c('tr', [_c('th', [_vm._v("剑桥标准")]), _vm._v(" "), _vm._l((_vm.levelCols), function(col) {
    return _c('td', {
      key: 'm' + col.code,
      class: {
        'is-on': col.code === _vm.levelText
      }
    }, [_vm._v(_vm._s(col.cam))])
  })], 2)])])]), _vm._v(" "), (_vm.formalLevelText) ? _c('p', {
    staticClass: "mex-rpt-level-note"
  }, [_vm._v("\n      当前综合等级为 "), _c('b', [_vm._v(_vm._s(_vm.levelBrief))]), _vm._v("，继续加油，向更高的等级迈进！\n    ")]) : (_vm.isPlacement && _vm.publishStatusText) ? _c('p', {
    staticClass: "mex-rpt-level-note"
  }, [_vm._v("\n      " + _vm._s(_vm.publishStatusText) + "，非正式定级\n      "), (_vm.candidateLevelText) ? [_vm._v("（候选 " + _vm._s(_vm.candidateLevelText) + "）")] : _vm._e(), _vm._v(" "), (_vm.visitedLevelText) ? [_vm._v("；最高触达 " + _vm._s(_vm.visitedLevelText))] : _vm._e(), _vm._v("。\n    ")], 2) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.showDimAnalysis) ? _c('div', {
    staticClass: "mex-rpt-card"
  }, [_c('h3', {
    staticClass: "mex-rpt-h"
  }, [_c('img', {
    staticClass: "mex-rpt-h-ico",
    attrs: {
      "src": _vm.dimIconSrc,
      "alt": ""
    }
  }), _vm._v("\n      能力维度分析\n    ")]), _vm._v(" "), _c('div', {
    staticClass: "mex-rpt-tabs"
  }, _vm._l((_vm.dimTabs), function(tab) {
    return _c('button', {
      key: tab.skill,
      staticClass: "mex-rpt-tab",
      class: {
        'is-on': tab.skill === _vm.activeSkill
      },
      attrs: {
        "type": "button"
      },
      on: {
        "click": function($event) {
          _vm.activeSkill = tab.skill
        }
      }
    }, [_vm._v(_vm._s(tab.label))])
  }), 0), _vm._v(" "), (_vm.activeDim) ? _c('div', {
    staticClass: "mex-rpt-dim"
  }, [_c('div', {
    staticClass: "mex-rpt-dim-head"
  }, [_c('div', {
    staticClass: "mex-rpt-dim-score"
  }, [_c('span', [_vm._v(_vm._s(_vm.dimScoreInt))]), _c('small', [_vm._v("分")])]), _vm._v(" "), (_vm.activeDim.speakDims) ? _c('div', {
    staticClass: "mex-rpt-3d"
  }, [_c('div', [_c('label', [_vm._v("准确度")]), _c('b', [_vm._v(_vm._s(_vm.num(_vm.activeDim.speakDims.accuracy)))])]), _vm._v(" "), _c('div', [_c('label', [_vm._v("流利度")]), _c('b', [_vm._v(_vm._s(_vm.num(_vm.activeDim.speakDims.fluency)))])]), _vm._v(" "), _c('div', [_c('label', [_vm._v("完整度")]), _c('b', [_vm._v(_vm._s(_vm.num(_vm.activeDim.speakDims.completeness)))])])]) : (_vm.activeDim.subs && _vm.activeDim.subs.length) ? _c('div', {
    staticClass: "mex-rpt-3d"
  }, _vm._l((_vm.activeDim.subs), function(sub) {
    return _c('div', {
      key: sub.code
    }, [_c('label', [_vm._v(_vm._s(sub.label))]), _vm._v(" "), _c('b', [_vm._v(_vm._s(_vm.num(sub.score)))])])
  }), 0) : _vm._e()]), _vm._v(" "), (_vm.activeDim.summary) ? _c('p', {
    staticClass: "mex-rpt-summary"
  }, [_vm._v(_vm._s(_vm.activeDim.summary))]) : _vm._e(), _vm._v(" "), _vm._l(((_vm.activeDim.items || [])), function(item) {
    return _c('div', {
      key: item.sessionItemId,
      staticClass: "mex-rpt-q"
    }, [_c('div', {
      staticClass: "mex-rpt-q-top"
    }, [_c('span', {
      staticClass: "mex-rpt-q-no"
    }, [_vm._v("第 " + _vm._s(item.seq) + " 题")]), _vm._v(" "), _c('span', {
      staticClass: "mex-rpt-q-diff"
    }, [_vm._v("难度")]), _vm._v(" "), _c('span', {
      staticClass: "mex-rpt-stars"
    }, [_vm._v(_vm._s(_vm.stars(item.difficultyLevel)))])]), _vm._v(" "), (item.audioUrl) ? _c('div', {
      staticClass: "mex-rpt-audio-block"
    }, [_c('p', [_vm._v("宝贝发音")]), _vm._v(" "), _c('audio', {
      staticClass: "mex-rpt-audio",
      attrs: {
        "src": item.audioUrl,
        "controls": ""
      }
    })]) : _vm._e(), _vm._v(" "), _c('div', {
      staticClass: "mex-rpt-q-actions"
    }, [(item.explanation) ? _c('button', {
      staticClass: "mex-rpt-btn-fill",
      attrs: {
        "type": "button"
      },
      on: {
        "click": function($event) {
          return _vm.toggleExplain(item.sessionItemId)
        }
      }
    }, [_vm._v("查看解析")]) : _vm._e(), _vm._v(" "), (_vm.sampleUrl(item)) ? _c('button', {
      staticClass: "mex-rpt-btn-ghost",
      attrs: {
        "type": "button"
      },
      on: {
        "click": function($event) {
          return _vm.toggleSample(item.sessionItemId)
        }
      }
    }, [_vm._v("示范音")]) : _vm._e()]), _vm._v(" "), (_vm.openedExplain[item.sessionItemId]) ? _c('p', {
      staticClass: "mex-rpt-explain"
    }, [_vm._v(_vm._s(item.explanation))]) : _vm._e(), _vm._v(" "), (_vm.openedSample[item.sessionItemId] && _vm.sampleUrl(item)) ? _c('audio', {
      staticClass: "mex-rpt-audio",
      attrs: {
        "src": _vm.sampleUrl(item),
        "controls": ""
      }
    }) : _vm._e()])
  }), _vm._v(" "), (!(_vm.activeDim.items && _vm.activeDim.items.length)) ? _c('p', {
    staticClass: "mex-rpt-hint"
  }, [_vm._v("该维暂无逐题")]) : _vm._e(), _vm._v(" "), (_vm.activeDim.tip) ? _c('p', {
    staticClass: "mex-rpt-tip"
  }, [_vm._v("小贴士：" + _vm._s(_vm.activeDim.tip))]) : _vm._e()], 2) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.report.advice) ? _c('div', {
    staticClass: "mex-rpt-card"
  }, [_c('h3', {
    staticClass: "mex-rpt-h"
  }, [_vm._v("学习建议")]), _vm._v(" "), _c('p', {
    staticClass: "mex-rpt-advice"
  }, [_vm._v(_vm._s(_vm.report.advice))])]) : _vm._e()]) : _vm._e()
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', [_c('i', {
    staticClass: "mex-rpt-dot mex-rpt-dot-self"
  }), _vm._v("本次测评")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('th', [_vm._v("美国 CCSS"), _c('br'), _vm._v("对应年级")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('th', [_vm._v("CEFR 欧洲"), _c('br'), _vm._v("共同语言标准")])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-345c94bc","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/mex/MexSessionReport.vue
// module id = 1726
// module chunks = 8